import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, Button, TextArea } from 'antd-mobile-v5';
import styles from './report.module.scss';
import report_chart_bg from '../../static/images_ae/report_chart_bg.png';
import report_bell from '../../static/images_ae/report_bell.png';
import report_doctor from '../../static/images_ae/report_doctor.png';
import report_chart_dialog from '../../static/images_ae/report_chart_dialog.png';
import report_dialog from '../../static/images_ae/report_dialog.png';
const api = new ApiCore();

const ChartReport = (props: any) => {

    const [text, setText] = useState<any>('')

    useEffect(() => {
        window.document.title = '问题上报';
    }, [])

    const textChange = (val: any) => {
        setText(val);
    }

    const toReport = () => {
        if (!text) {
            Toast.show({
                content: '输入内容不能为空',
                duration: 1000
            })
        } else {
            api.submitIssueAsk({
                content: 'text'
            }).then((res: any) => {
                if (res.code == 0) {
                    Toast.show({
                        content: '提交成功',
                        duration: 1000
                    })
                }
            })
        }
    }

    return (
        <div className={styles.chart_report_content}>
            <div className={styles.chart_tip}>
                <img src={report_bell} alt="" />
                <span>回复内容仅作为健康资讯参考，不作为诊断意见</span>
            </div>
            <div className={styles.doctor_tip}>
                <img src={report_doctor} alt="" />
                <div className={styles.doctor_tip_dialog}>
                    <div className={styles.top}>您遇到了什么问题？</div>
                    <div className={styles.bottom}>
                        请将您遇到的问题或要反馈的内容填写在下方输入框内，填写完成后点击提交问题完成上报。我们会尽可能对您上报的问题进行反馈。
                    </div>
                </div>
            </div>
            <div className={styles.input_dialog}>
                <div className={styles.input_dialog_wrap}>
                    <TextArea maxLength={150} value={text} onChange={textChange} placeholder='请输入您遇到的问题......' />
                </div>
            </div>
            <div></div>
            <div className={styles.btn_wrap}>
                <Button color='primary' onClick={toReport}>提交问题</Button>
            </div>
        </div>
    )
}

export default ChartReport;